/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=78f4fbad&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=78f4fbad&scoped=true&lang=css"

import exportComponent from "D:\\源码\\frontend\\vue-wms-mobile-3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78f4fbad"]])

export default __exports__